
import React from 'react'
import { getElementDisplayName } from '../../utils/getElementDisplayName'
import { Select } from 'alurkerja-ui'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'

type PropertyConfig = {
  key: string
  label: string
  options: Array<{ value: string; label: string }>
  defaultValue: string
}

type EditButtonPropertiesProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
  properties?: PropertyConfig[]
}

const defaultButtonProperties: PropertyConfig[] = [
  {
    key: 'type',
    label: 'Button Type',
    options: [
      { value: 'submit', label: 'Submit' },
      { value: 'button', label: 'Button' },
      { value: 'reset', label: 'Reset' },
    ],
    defaultValue: 'submit',
  },
  {
    key: 'color',
    label: 'Color',
    options: [
      { value: 'primary', label: 'Primary' },
      { value: 'secondary', label: 'Secondary' },
      { value: 'blue', label: 'Blue' },
      { value: 'red', label: 'Red' },
      { value: 'orange', label: 'Orange' },
      { value: 'green', label: 'Green' },
      { value: 'danger', label: 'Danger' },
      { value: 'warning', label: 'Warning' },
      { value: 'info', label: 'Info' },
      { value: 'light-danger', label: 'Light Danger' },
    ],
    defaultValue: 'primary',
  },
  {
    key: 'variant',
    label: 'Variant',
    options: [
      { value: 'filled', label: 'Filled' },
      { value: 'outlined', label: 'Outlined' },
      { value: 'text', label: 'Text' },
    ],
    defaultValue: 'filled',
  },

  {
    key: 'rounded',
    label: 'Rounded',
    options: [
      { value: 'sm', label: 'Small' },
      { value: 'md', label: 'Medium' },
      { value: 'lg', label: 'Large' },
      { value: 'full', label: 'Full' },
    ],
    defaultValue: 'md',
  },
  {
    key: 'size',
    label: 'Size',
    options: [
      { value: 'small', label: 'Small' },
      { value: 'medium', label: 'Medium' },
    ],
    defaultValue: 'medium',
  },
]

export default function EditButtonProperties(props: EditButtonPropertiesProps) {
  const { index, element, currentElementState, setCurrentElementState, properties = defaultButtonProperties } = props

  const handlePropertyChange = (propertyKey: string, value: string) => {
    setCurrentElementState((prevState: any) => ({
      ...prevState,
      [propertyKey]: value,
    }))
  }

  return (
    <>
      <div key={index} className="p-3 py-2 rounded-sm space-y-3">
        <div className="font-semibold">{stringToTitleCase(getElementDisplayName(element))} Properties</div>

        {properties.map((property) => (
          <div key={property.key} className="space-y-1">
            <label className="block text-xs font-medium text-gray-600">{property.label}</label>
            <Select
              options={property.options}
              isSearchable={false}
              size="sm"
              rounded="lg"
              defaultValue={{
                value: currentElementState[property.key] || property.defaultValue,
                label:
                  property.options.find(
                    (opt) => opt.value === (currentElementState[property.key] || property.defaultValue)
                  )?.label || stringToTitleCase(property.defaultValue),
              }}
              onChange={(e) => {
                handlePropertyChange(property.key, (e as { value: string }).value)
              }}
            />
          </div>
        ))}
      </div>
    </>
  )
}
